/**
 * Contact Form Component
 */

import { BaseForm } from "./base-form";
import { submitContactForm } from "../../services/forms";

export class ContactForm extends BaseForm {
  constructor(element, options = {}) {
    super(element, {
      resetOnSuccess: true,
      ...options,
    });

    // Store original submit button text
    this.$submitButton.data("original-text", this.$submitButton.text());
  }

  /**
   * Get additional form data
   */
  getAdditionalData() {
    return {
      action: "submit_contact_form",
    };
  }

  /**
   * Submit the contact form
   */
  async submitForm(formData) {
    return await submitContactForm(formData);
  }

  /**
   * Handle successful submission
   */
  onSuccess(response) {
    const message =
      response.data?.message ||
      window.hs?.strings?.contactFormSuccess ||
      "Bedankt voor je bericht. We nemen snel contact met je op.";

    const sentText = window.hs?.strings?.sent || "Verzonden!";

    // Replace form with success message
    this.$form.html(`
      <div class="bg-green-50 border border-green-200 text-green-700 px-6 py-4 rounded-lg">
        <div class="flex items-center mb-2">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>
          <span class="font-semibold">${sentText}</span>
        </div>
        <p>${message}</p>
      </div>
    `);
  }
}

/**
 * Create contact form instance
 * @deprecated Use ContactForm class directly
 */
export const createContactForm = (element) => {
  return new ContactForm(element);
};
